var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import DataObjectIcon from '@mui/icons-material/DataObject';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import DownloadingIcon from '@mui/icons-material/Downloading';
import SyncProblemIcon from '@mui/icons-material/SyncProblem';
import CircularProgress from '@mui/material/CircularProgress';
import styles from './CatalogStatusRow.module.scss';
import { CatalogProcessStatus } from '../../../models/catalogs/CatalogProcess';
function rowClass(status) {
    switch (status) {
        case CatalogProcessStatus.FAILED:
            return styles.failedRow;
        case CatalogProcessStatus.COMPLETED_WITH_ISSUE:
        case CatalogProcessStatus.UNKNOWN:
            return styles.warningRow;
        default:
            return '';
    }
}
function statusIcon(status) {
    switch (status) {
        case CatalogProcessStatus.COMPLETED:
            return _jsx(Tooltip, __assign({ title: "Sync Complete, No Issues" }, { children: _jsx(TaskAltIcon, { fontSize: "large" }) }));
        case CatalogProcessStatus.COMPLETED_WITH_ISSUE:
            return _jsx(Tooltip, __assign({ title: "Sync Complete, Issues Found" }, { children: _jsx(WarningAmberIcon, { fontSize: "large" }) }));
        case CatalogProcessStatus.FAILED:
            return _jsx(Tooltip, __assign({ title: "Incomplete" }, { children: _jsx(HighlightOffIcon, { fontSize: "large" }) }));
        case CatalogProcessStatus.IN_PROGRESS:
            return _jsx(Tooltip, __assign({ title: "In Progress" }, { children: _jsx(DownloadingIcon, { fontSize: "large" }) }));
        default:
            return _jsx(Tooltip, __assign({ title: "Error Retrieving Status" }, { children: _jsx(SyncProblemIcon, { fontSize: "large" }) }));
    }
}
export function CatalogStatusRow(_a) {
    var processName = _a.processName, syncStatus = _a.syncStatus, loading = _a.loading, onJsonClick = _a.onJsonClick;
    if (loading || !syncStatus) {
        return _jsxs(TableRow, { children: [_jsx(TableCell, { children: _jsx(Box, { children: processName }) }), _jsx(TableCell, __assign({ colSpan: 6, className: styles.tableCell, align: "center" }, { children: _jsx(CircularProgress, { size: 24 }) }))] }, processName);
    }
    return _jsxs(TableRow, __assign({ className: rowClass(syncStatus.status) }, { children: [_jsx(TableCell, { children: _jsx(Box, { children: processName }) }), _jsx(TableCell, __assign({ className: styles.tableCell }, { children: _jsx(Box, { children: statusIcon(syncStatus.status) }) })), _jsxs(TableCell, __assign({ className: styles.tableCell }, { children: [syncStatus.lastCompletionEnd && _jsx(Box, { children: syncStatus.lastCompletionEnd }), syncStatus.lastCompletedElapsed &&
                        _jsx(Box, __assign({ fontStyle: "italic" }, { children: syncStatus.lastCompletedElapsed }))] })), _jsx(TableCell, __assign({ className: styles.tableCell }, { children: syncStatus.executionInProgress && syncStatus.executionStart && (_jsxs(_Fragment, { children: [_jsx(Box, { children: syncStatus.executionStart }), _jsx(Box, __assign({ fontStyle: "italic" }, { children: syncStatus.executionElapsed }))] })) })), _jsx(TableCell, __assign({ className: styles.tableCell }, { children: syncStatus.processesRemaining === undefined ? _jsx(Box, { children: "n/a" }) :
                    _jsx(Box, { children: syncStatus.processesRemaining }) })), _jsx(TableCell, __assign({ className: styles.tableCell }, { children: syncStatus.nextScheduledRun && _jsx(Box, { children: syncStatus.nextScheduledRun }) })), _jsx(TableCell, __assign({ className: styles.tableCell }, { children: _jsx(Box, { children: _jsx(Tooltip, __assign({ title: "Raw JSON" }, { children: _jsx(IconButton, __assign({ "aria-label": "View raw JSON for ".concat(processName), sx: { padding: '0' }, onClick: function () { return onJsonClick(syncStatus.fullPayload); } }, { children: _jsx(DataObjectIcon, {}) })) })) }) }))] }), processName);
}
